export default "__VITE_ASSET__LtUkBifb__"